import axios from './axios';

export const getList = ({ list, language, searchText, count = 500, page, searchType }) => {
    let url = `/valuelist/v1/${list}`;

    let params = [];
    if (page) params.push(`page=${page}`);
    if (language) params.push(`lang=${language.toUpperCase()}`);
    if (searchText) params.push(`searchText=${searchText}`);
    // searchType searches by name (0) / id (1) / extId (2)
    if (searchType) params.push(`searchType=${searchType}`);
    if (params.length) url += `?${params.join('&')}`;

    return axios.get(url, {
        headers: {
            count,
        },
    });
};

export const getTableId = (tableName) => {
    return axios.get(`/tables/v1/id/${tableName}`);
};

export const getTable = (id) => {
    return axios.get(`/tables/v1/${id}`);
};

export const getValues = (id, offset) => {
    return axios.get(`/tables/v1/${id}/values?offset=${offset}`);
};

export const searchValues = ({ entity, text, lang = '', count = 10 }) => {
    return axios.get(`/search/v1/fuzzySearch/${entity}`, {
        params: { count, text, lang },
    });
};

export const searchValuesByIds = ({ entity, ids, lang = '', fields, searchType }) => {
    // searchType searches by name (0) / id (1) / extId (2)
    return axios.post(`/search/v1/fuzzySearch/${entity}/values`, { ids, lang, fields, searchType });
};

let INNER_VALUE_CACHE = {};
export function getEntityValue(entityName, ids) {
    if (!entityName || !ids) return Promise.reject('Entity and id is needed');
    INNER_VALUE_CACHE[entityName] = INNER_VALUE_CACHE[entityName] || {};
    const uncachedIds = ids.filter((id) => !INNER_VALUE_CACHE[entityName][id]);

    if (uncachedIds.length === 0) {
        const cachedResults = Object.fromEntries(
            ids.map((id) => [id, INNER_VALUE_CACHE[entityName][id]]),
        );
        return Promise.resolve({ data: cachedResults });
    }

    return axios
        .get(`/search/v1/fuzzySearch/${entityName}/values?ids[]=${uncachedIds.join(',')}`)
        .then((result) => {
            Object.entries(result.data).forEach(([id, item]) => {
                INNER_VALUE_CACHE[entityName][id] = item;
            });

            return {
                data: Object.fromEntries(ids.map((id) => [id, INNER_VALUE_CACHE[entityName][id]])),
            };
        });
}

export const getValueLists = () => {
    return axios.get('/tables/v1');
};

export const createTable = (data) => {
    return axios.post(`/tables/v1`, data);
};

export const updateTable = (id, data) => {
    return axios.put(`/tables/v1/${id}`, data);
};

export const deleteValueList = (id) => {
    return axios.delete(`/tables/v1/${id}`);
};

export const getValue = (list, id, lang) => {
    let url = `valuelist/v1/${list}/${id}`;
    if (lang) url += `?lang=${lang.toUpperCase()}`;
    return axios.get(url);
};

export const getValueDetails = (id, idValue) => axios.get(`/tables/v1/${id}/values/${idValue}`);

export const getValueListPage = (page = 0, list) => axios.get(`/list/v1/${list}?page=${page}`);

export const getValuesUsage = (id, idValue) =>
    axios.get(`/tables/v1/${id}/values/${idValue}/usages`);

export const updateValueListOrder = (id, data) => axios.put(`/tables/v1/${id}/values/sort`, data);
